export const navigationDrawerDimensions = {
  header: 72,
  footer: 144,
}

export const navigationDrawerClasses = {
  logo: 'navigation-drawer-logo',
  logoFanatics: 'navigation-drawer-logo-fanatics',
  crossIcon: 'navigation-cross-icon',
  chevronIcon: 'navigation-chevron-icon',
  chevronRightIcon: 'navigation-chevron-right-icon',
  chevronLeftIcon: 'navigation-chevron-left-icon',
  flagIcon: 'navigation-flag-icon',
}
